/* src/app/shared/entity-affiliation/entity-affiliation.component.scss */
.cw-table-heading {
  padding: 15pt 0 1pt 0;
}
/*# sourceMappingURL=entity-affiliation.component.css.map */
